// src/theme/theme.js
// Main theme configuration file for MUI
// All comments in English only

import { createTheme } from '@mui/material/styles';
import { palette, darkPalette } from './palette';
import { components } from './components';

// Typography configuration
const typography = {
  fontFamily: [
    'Poppins',
    'Inter',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  h1: {
    fontSize: '2.5rem',
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: '-0.01562em',
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: '-0.00833em',
  },
  h3: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: '0em',
  },
  h4: {
    fontSize: '1.5rem',
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: '0.00735em',
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: '0em',
  },
  h6: {
    fontSize: '1.125rem',
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: '0.0075em',
  },
  button: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.4,
    letterSpacing: '0.02857em',
    textTransform: 'none',
  },
};

// Shape configuration
const shape = {
  borderRadius: "6px",
};

// Custom shadows
const customShadows = {
  // Primary button shadows
  primaryButton: '0px 13px 9.7px -8px rgba(32, 141, 244, 0.24)',
  primaryButtonHover: '0px 16px 12px -8px rgba(32, 141, 244, 0.32)',
  
  // Card shadows
  cardDefault: '0 2px 8px rgba(0,0,0,0.1)',
  cardHover: '0 8px 16px rgba(0,0,0,0.15)',
  cardElevated: '0 4px 12px rgba(0,0,0,0.12)',
  
  // Button shadows
  buttonDefault: '0 2px 4px rgba(0,0,0,0.1)',
  buttonHover: '0 4px 8px rgba(0,0,0,0.12)',
  buttonElevated: '0 4px 8px rgba(0,0,0,0.15)',
  
  // AppBar shadows
  appBar: '0 2px 4px rgba(0,0,0,0.1)',
  
  // Paper shadows
  paperDefault: '0 2px 8px rgba(0,0,0,0.1)',
  paperElevation1: '0 2px 4px rgba(0,0,0,0.1)',
  paperElevation2: '0 4px 8px rgba(0,0,0,0.12)',
  paperElevation3: '0 8px 16px rgba(0,0,0,0.15)',
};

// Create light theme
export const lightTheme = createTheme({
  palette,
  typography,
  shape,
  components,
  customShadows,
});

// Create dark theme
export const darkTheme = createTheme({
  palette: darkPalette,
  typography,
  shape,
  components,
  customShadows,
});

// Default theme export (light theme)
export default lightTheme; 